import PropTypes from 'prop-types';
import React, { FC } from 'react';
import CollapsilbleContent from '../collapsible/CollapsibleContent';
import { Ellipsis, Kind, Prefix, PublicId, Signature, Transformation, Version } from './Sections';

export interface SectionsFromObjectProps {
  /** Content of the prefix section */
  prefix?: string;
  /** Content of the kind section */
  kind?: string;
  /** Content of the signature section */
  signature?: string;
  /** Content of the transformation section */
  transformation?: string;
  /** Content of the version section */
  version?: string;
  /** Content of the publicId section */
  publicId?: string;
}

/**
 * This component provides a simple way to build a collapsible URL with single section per each
 * URL property if present. You can use the output of `@cld/cloudinary-url-parser` to populate it.
 */
const SectionsFromObject: FC<SectionsFromObjectProps> = ({ prefix, kind, signature, transformation, version, publicId }) => (
  <>
    <CollapsilbleContent replacement={<Ellipsis />}>
      {prefix && <Prefix>{prefix}</Prefix>}
      {kind && <Kind>{kind}</Kind>}
    </CollapsilbleContent>
    {signature && <Signature>{signature}</Signature>}
    {transformation && <Transformation>{transformation}</Transformation>}
    {version && <Version>{version}</Version>}
    {publicId && <PublicId>{publicId}</PublicId>}
  </>
);

SectionsFromObject.propTypes = {
  prefix: PropTypes.string,
  kind: PropTypes.string,
  signature: PropTypes.string,
  transformation: PropTypes.string,
  version: PropTypes.string,
  publicId: PropTypes.string,
};

export default SectionsFromObject;
